var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5861_19013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.667 76.876L44.6818 131.379L52.3225 135.874L138.064 86.4165C130.677 117.156 103.006 140 70 140C37.1098 140 9.51763 117.316 2.01432 86.7402L90.9752 35.4262L139.712 63.6126C139.903 65.7162 140 67.8468 140 70C140 72.3201 139.887 74.6138 139.667 76.876ZM118.25 19.2854C127.736 28.3133 134.692 39.9751 137.946 53.0984L98.8406 30.4825L118.25 19.2854ZM112.167 14.1205C100.439 5.25688 85.8334 0 70 0C47.3794 0 27.2648 10.7297 14.4681 27.3773L51.873 48.9091L112.167 14.1205ZM10.1015 33.7563C3.69073 44.3284 0 56.7332 0 70C0 72.9339 0.180501 75.8257 0.531005 78.6648L44.2324 53.4034L10.1015 33.7563Z",
    fill: "#EEF9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7168 114.066L97.2835 101.094V81.5477L74.7168 94.5195V114.066Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5996 94.5194L74.7162 114.066V94.5194L40.5996 74.7952V94.5194Z",
    fill: "#5FD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1663 61.8234L97.2829 81.5477L74.7162 94.5195L40.5996 74.7952L63.1663 61.8234Z",
    fill: "#5FD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7078 75.506L46.8193 74.9729L59.2577 67.8651L75.9606 77.4606L74.8944 78.1714L59.2577 68.9312L47.7078 75.506Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7075 75.506L59.2574 68.9313L74.8942 78.1715L63.522 84.7462L47.7075 75.506Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.167 107.314L69.5639 111.223V97.3626L63.167 93.4533V107.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0555 94.1641V108.024L63.167 107.314V93.4533L64.0555 94.1641Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9761 92.3871L57.6582 100.383V91.1433L43.9761 83.1469V92.3871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9761 83.1469L45.0422 83.8577V93.0979L43.9761 92.3871V83.1469Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1966 89.3663V98.2511L92.3081 98.7842V89.8994L93.1966 89.3663Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2251 96.8295L92.308 89.8994V98.7842L80.2251 105.714V96.8295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3788 86.038C73.5499 88.2058 67.3509 88.2058 63.522 86.038C59.6932 83.8703 59.6932 80.3477 63.522 78.0896C67.3509 75.9219 73.5499 75.9219 77.3788 78.0896C81.2076 80.2574 81.2076 83.8703 77.3788 86.038Z",
    fill: "#0081B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7655 41.2028C66.7655 40.3777 66.9031 39.69 67.0406 39.1399C63.8775 38.3147 61.5396 40.2401 61.5396 44.2285C61.5396 48.9045 64.8402 54.6808 68.9659 57.0188C72.4041 58.9442 75.2921 57.9815 76.1173 54.8183C75.5672 54.6808 74.8796 54.4057 74.1919 53.9931C70.0662 51.6551 66.7655 46.0164 66.7655 41.2028Z",
    fill: "#0B9CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4915 28.4126C69.9159 26.3496 66.4777 26.0745 64.0022 27.4498C63.7272 27.5874 63.5897 27.7249 63.3146 27.8624L59.8765 29.9254C62.2144 29.1002 65.1024 29.5128 68.2655 31.3007C76.242 35.8392 82.5682 47.8043 82.5682 57.844C82.5682 67.8837 68.2655 83.012 68.2655 83.012L73.4915 79.9864C73.4915 79.9864 87.7942 64.858 87.7942 54.8183C87.7942 44.7786 81.3305 32.9511 73.4915 28.4126Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5249 41.3404C54.5249 51.3801 68.8276 83.012 68.8276 83.012C68.8276 83.012 83.1303 67.8837 83.1303 57.844C83.1303 47.8043 76.6666 35.9767 68.8276 31.3007C65.6645 29.5128 62.7765 29.1002 60.4385 29.9254C56.8628 31.1632 54.5249 35.1515 54.5249 41.3404ZM68.9651 57.0188C64.8393 54.6808 61.5387 48.9046 61.5387 44.2285C61.5387 40.2402 63.8767 38.3147 67.0397 39.1399C67.5899 39.2774 68.2775 39.5525 68.9651 39.9651C73.0909 42.3031 76.3915 48.0794 76.3915 52.7554C76.3915 53.5806 76.254 54.2682 76.1164 54.8183C75.1538 57.9815 72.4033 59.0818 68.9651 57.0188Z",
    fill: "url(#paint0_linear_5861_19013)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5861_19013",
    x1: 69.0504,
    y1: 85.5638,
    x2: 79.5515,
    y2: 49.1641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819473,
    stopColor: "#45B6E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5861_19013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker3D);
export default __webpack_public_path__ + "static/media/map-marker-3d.1bab7ec21c9815f01c4ffbf995788921.svg";
export { ForwardRef as ReactComponent };